import React, { useEffect, useRef, useState } from 'react';
import LazyLoader from './LazyLoader';

const Team = () => {
    const [isFirstSectionVisible, setIsFirstSectionVisible] = useState(false);
    const [isInViewFirst, setIsInViewFirst] = useState(false);

    const firstSectionRef = useRef(null);
    const firstElementRef = useRef(null);

    useEffect(() => {
        const observerFirst = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setIsFirstSectionVisible(true);
                }
            },
            {
                threshold: 0.5,
            }
        );

        const observerSecond = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setIsInViewFirst(true);
                }
            },
            {
                threshold: 0.5,
            }
        );

        if (firstSectionRef.current) {
            observerFirst.observe(firstSectionRef.current);
        }

        if (firstElementRef.current) {
            observerSecond.observe(firstElementRef.current);
        }

        return () => {
            if (firstSectionRef.current) {
                observerFirst.unobserve(firstSectionRef.current);
            }
            if (firstElementRef.current) {
                observerSecond.unobserve(firstElementRef.current);
            }
        };
    }, []);

    return (
        <div className="flex flex-wrap w-full pb-80 custom-padding xl-screen-padding gap-4 md:gap-16">
            <div className={`w-full md:w-7/12 space-left-extra content-container-tab md:pt-0 ${isFirstSectionVisible ? "animate-slide-up" : ""}`}>
                <h2
                    ref={firstElementRef}
                    className={`custom-padding-bottom text-[#2b343b] text-h2 font-semibold text-gray-800 client-text ${isInViewFirst ? 'typewriter-effect' : ''}`}
                >
                    <span className='text-4xl'>
                        <span className="text-black">Our</span> <span className="text-[#8f762c] ">Team</span>
                    </span>
                </h2>
                <p className="custom-padding-bottom text-p font-lato text-[#6f787e]">
                    At Nutrillion, what sets us apart is the strength and expertise of our clinical team. We are
                    a diverse group of professionals brought together by a shared passion for science,
                    innovation, and the transformative potential of personalised nutrition.
                </p>
                <p className="custom-padding-bottom text-p font-lato text-[#6f787e]">
                    Our team includes specialists in molecular biology, genetics, and clinical nutritionalists,
                    who work collaboratively to offer insights in the field of nutrigenomics. Together, we
                    blend scientific research with practical applications to design personalised solutions that
                    support individuals to achieve optimal health.
                </p>
                <p className="custom-padding-bottom text-p font-lato text-[#6f787e]">
                    By leveraging our collective expertise, we stay at the forefront of advancements in
                    nutrigenomics and also ensure that every solution we develop is deeply rooted in science
                    and tailored to individual needs. It’s this combination of collaboration, and scientific
                    precision that makes Nutrillion a leader in personalised nutrition and a trusted partner on
                    your health journey.
                </p>
            </div>

            <div className={`w-full md:w-4/12 custom-width relative teamimg ${isFirstSectionVisible ? "animate-slide-up" : ""} mr-6`}>
                <div className="relative col-tablet rounded-lg flex items-center justify-center md:justify-end">
                    <LazyLoader
                        src={require("../../src/assets/images/team1.png")}
                        alt="Salad Bowl"
                        placeholder="#f0f0f0"
                        className="object-cover rounded-full w-80 h-auto"
                    />
                    <div className="absolute small_circle top-[200px] right-[220px] p-2 rounded-full hover-effect">
                        <LazyLoader
                            src={require("../../src/assets/images/team2.png")}
                            alt="Scanning Food Data"
                            placeholder="#f0f0f0"
                            className="object-cover w-52 h-52 rounded-full"
                        />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Team;
